import api, { API } from "@/lib/api";

// Tours
export const adminGetTours = () => api.get("/tours/admin/all").then((r) => r.data);
export const adminCreateTour = (d) => api.post("/tours", d).then((r) => r.data);
export const adminUpdateTour = (id, d) => api.put(`/tours/${id}`, d).then((r) => r.data);
export const adminDeleteTour = (id) => api.delete(`/tours/${id}`).then((r) => r.data);
export const adminDuplicateTour = (id) => api.post(`/tours/${id}/duplicate`).then((r) => r.data);

// Destinations
export const adminGetDestinations = () => api.get("/destinations/admin/all").then((r) => r.data);
export const adminCreateDestination = (d) => api.post("/destinations", d).then((r) => r.data);
export const adminUpdateDestination = (id, d) => api.put(`/destinations/${id}`, d).then((r) => r.data);
export const adminDeleteDestination = (id) => api.delete(`/destinations/${id}`).then((r) => r.data);

// Blog
export const adminGetBlog = () => api.get("/blog/admin/all").then((r) => r.data);
export const adminGetPost = (slug) => api.get(`/blog/${slug}`).then((r) => r.data);
export const adminCreatePost = (d) => api.post("/blog", d).then((r) => r.data);
export const adminUpdatePost = (id, d) => api.put(`/blog/${id}`, d).then((r) => r.data);
export const adminDeletePost = (id) => api.delete(`/blog/${id}`).then((r) => r.data);

// Testimonials
export const adminGetTestimonials = () => api.get("/testimonials/admin/all").then((r) => r.data);
export const adminCreateTestimonial = (d) => api.post("/testimonials", d).then((r) => r.data);
export const adminUpdateTestimonial = (id, d) => api.put(`/testimonials/${id}`, d).then((r) => r.data);
export const adminDeleteTestimonial = (id) => api.delete(`/testimonials/${id}`).then((r) => r.data);

// Enquiries
export const adminGetEnquiries = () => api.get("/enquiries/admin/all").then((r) => r.data);
export const adminUpdateEnquiryStatus = (id, status) => api.put(`/enquiries/${id}/status`, { status }).then((r) => r.data);
export const adminDeleteEnquiry = (id) => api.delete(`/enquiries/${id}`).then((r) => r.data);
export const enquiriesCsvUrl = `${API}/enquiries/admin/export.csv`;

// FAQ
export const adminGetFaqs = () => api.get("/faqs").then((r) => r.data);
export const adminCreateFaq = (d) => api.post("/faqs", d).then((r) => r.data);
export const adminUpdateFaq = (id, d) => api.put(`/faqs/${id}`, d).then((r) => r.data);
export const adminDeleteFaq = (id) => api.delete(`/faqs/${id}`).then((r) => r.data);

// Singletons
export const adminGetHomepage = () => api.get("/homepage").then((r) => r.data);
export const adminUpdateHomepage = (d) => api.put("/homepage", d).then((r) => r.data);
export const adminGetSettings = () => api.get("/settings").then((r) => r.data);
export const adminUpdateSettings = (d) => api.put("/settings", d).then((r) => r.data);

// Stats
export const adminGetStats = () => api.get("/admin/stats").then((r) => r.data);

// Users
export const adminGetUsers = () => api.get("/auth/users").then((r) => r.data);
export const adminCreateUser = (d) => api.post("/auth/users", d).then((r) => r.data);
export const adminUpdateUser = (id, d) => api.put(`/auth/users/${id}`, d).then((r) => r.data);
export const adminDeleteUser = (id) => api.delete(`/auth/users/${id}`).then((r) => r.data);

// Media
export const adminUploadMedia = (payload) => api.post("/media", payload).then((r) => r.data);
export const adminListMedia = (params) => api.get("/media", { params }).then((r) => r.data);
export const adminListMediaFolders = () => api.get("/media/folders").then((r) => r.data);
export const adminRenameMedia = (id, payload) => api.put(`/media/${id}`, payload).then((r) => r.data);
export const adminDeleteMedia = (id) => api.delete(`/media/${id}`).then((r) => r.data);

// Pages (editable public pages)
export const adminGetPages = () => api.get("/pages").then((r) => r.data);
export const adminGetPage = (slug) => api.get(`/pages/${slug}`).then((r) => r.data);
export const adminUpdatePage = (slug, d) => api.put(`/pages/${slug}`, d).then((r) => r.data);
export const adminResetPage = (slug) => api.post(`/pages/${slug}/reset`).then((r) => r.data);

// Upload a File as base64 -> returns absolute raw URL
export async function uploadImageFile(file, folder = "General") {
  const dataUrl = await new Promise((res, rej) => {
    const reader = new FileReader();
    reader.onload = () => res(reader.result);
    reader.onerror = rej;
    reader.readAsDataURL(file);
  });
  const media = await adminUploadMedia({ name: file.name, data: dataUrl, folder });
  return `${process.env.REACT_APP_BACKEND_URL}${media.url}`;
}
